import type { StatusVariant } from '@factorialco/f0-react'
import i18n from 'modules/core/lib/i18n'

export const PLANNING_PERIOD_STATUS = {
  ACTIVE: 'active',
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
  TO_BE_REVIEWED: 'to_be_reviewed',
  REVIEWED: 'reviewed',
  CLOSED: 'closed',
} as const

export type PlanningPeriodStatus =
  (typeof PLANNING_PERIOD_STATUS)[keyof typeof PLANNING_PERIOD_STATUS]

export const PLANNING_PERIOD_STATUS_COLORS: Record<PlanningPeriodStatus, StatusVariant> = {
  [PLANNING_PERIOD_STATUS.ACTIVE]: 'positive',
  [PLANNING_PERIOD_STATUS.DRAFT]: 'neutral',
  [PLANNING_PERIOD_STATUS.SCHEDULED]: 'info',
  [PLANNING_PERIOD_STATUS.TO_BE_REVIEWED]: 'warning',
  [PLANNING_PERIOD_STATUS.REVIEWED]: 'positive',
  [PLANNING_PERIOD_STATUS.CLOSED]: 'critical',
}

export function getPeriodStatusLabel(status: PlanningPeriodStatus): string {
  return {
    [PLANNING_PERIOD_STATUS.ACTIVE]: i18n.t('planning.periods_page.period_status.active'),
    [PLANNING_PERIOD_STATUS.DRAFT]: i18n.t('planning.periods_page.period_status.draft'),
    [PLANNING_PERIOD_STATUS.SCHEDULED]: i18n.t('planning.periods_page.period_status.scheduled'),
    [PLANNING_PERIOD_STATUS.TO_BE_REVIEWED]: i18n.t(
      'planning.periods_page.period_status.to_be_reviewed'
    ),
    [PLANNING_PERIOD_STATUS.REVIEWED]: i18n.t('planning.periods_page.period_status.reviewed'),
    [PLANNING_PERIOD_STATUS.CLOSED]: i18n.t('planning.periods_page.period_status.closed'),
  }[status]
}
